import { Component } from 'react'
import PropTypes from 'prop-types'
import ImageUploadPreviewer from 'shared/image-upload-previewer/image-upload-previewer'
import { CurrencyInput, Input } from 'components/forms'
import { LinkButton } from 'components/buttons'
import Quantity from 'components/quantity'
import FavoriteToggle from 'shared/reg-item-form/components/favorite-toggle'
import GroupGiftToggle from 'shared/reg-item-form/components/group-gift-toggle'
import { REG_ITEM_PLACEHOLDER_TEXT } from 'registry/constants'
import CategorySelector from './category-selector'
import css from './reg-item-form.scss'

export default class RegItemFields extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSecondaryUrlForm: false,
    }
  }

  handleImageChange = ({ imgUrl }) => {
    const { onRegItemChange } = this.props
    onRegItemChange({ imgUrl })
  }

  handleFavoriteChange = (isOn) => {
    const { onRegItemChange } = this.props
    onRegItemChange({ isFavorite: isOn })
  }

  handleGroupGiftChange = (isOn) => {
    const { openEnableGroupGiftModal, onRegItemChange, regItem } = this.props

    if (regItem.isGroupGift) {
      onRegItemChange({ isGroupGift: isOn })
    } else {
      openEnableGroupGiftModal()
    }
  }

  handleGroupGiftDisabled = () => {
    const { openEnableGroupGiftModal, regItem } = this.props
    const { groupGiftingDisabledMessage } = regItem
    // This modal handles the concern for displaying a message
    // when regItem canEnableGroupGift = false
    if (groupGiftingDisabledMessage) {
      openEnableGroupGiftModal()
    }
  }

  handleQuantityChange = (value) => {
    const { onRegItemChange } = this.props
    onRegItemChange({ quantity: value })
  }

  handleChange = (e) => {
    const { onRegItemChange } = this.props
    onRegItemChange({ [e.target.name]: e.target.value })
  }

  toggleSecondaryUrl = () => {
    const { showSecondaryUrlForm } = this.state
    this.setState({ showSecondaryUrlForm: !showSecondaryUrlForm })
  }

  isSecondPriceValid = () => {
    const { regItem } = this.props
    const { secondPrice, secondUrl } = regItem
    return (
      !secondPrice ||
      secondPrice.length === 0 ||
      (secondUrl && secondUrl.length > 0)
    )
  }

  renderSecondaryUrl = () => {
    const { regItem } = this.props
    const { secondUrl, secondPrice } = regItem
    const { showSecondaryUrlForm } = this.state

    return (
      <>
        {(showSecondaryUrlForm || secondUrl || secondPrice) && (
          <div className="inline-form mts">
            <Input
              label="Alternate Url"
              name="secondUrl"
              value={secondUrl || ''}
              onChange={this.handleChange}
              groupClassName="flex-grow"
            />
            <CurrencyInput
              label="Alternate Price"
              name="secondPrice"
              value={secondPrice || ''}
              onChange={this.handleChange}
              error={
                this.isSecondPriceValid() ? null : 'Alternate URL is required.'
              }
              groupClassName="flex-grow"
            />
          </div>
        )}
      </>
    )
  }

  render() {
    const { categories, regItem, onRegItemChange, onNewCategoryChange } =
      this.props
    const regItemFields = regItem
    const {
      addedViaBabylist,
      canEnableGroupGift,
      description,
      imgUrl,
      isFavorite,
      isGroupGift,
      secondUrl,
      secondPrice,
      showGroupGiftToggle,
      price,
      quantity,
      title,
      url,
    } = regItemFields

    return (
      <>
        <div className={css.item}>
          <div className={css.imageContainer}>
            <ImageUploadPreviewer
              imgUrl={imgUrl}
              onChange={this.handleImageChange}
            />
          </div>

          <div className={css.itemFields}>
            <Input
              label="Title"
              value={title}
              onChange={this.handleChange}
              name="title"
              disabled={addedViaBabylist}
              error={title ? null : 'Title cannot be blank'}
            />

            <div className="inline-form mbl">
              <CurrencyInput
                label="Price"
                value={price || ''}
                onChange={this.handleChange}
                name="price"
                groupClassName="flex-grow"
              />
              <Quantity
                className="flex-grow"
                value={quantity}
                onChange={this.handleQuantityChange}
                unlimited
              />
            </div>

            <div className="flex inline-form">
              <CategorySelector
                groupClassName="flex-grow"
                name="categoryId"
                value={regItemFields.categoryId}
                categories={categories}
                onCategoryChange={onRegItemChange}
                onCategoryAdd={onNewCategoryChange}
              />
              <div className="flex flex-grow form-group">
                <FavoriteToggle
                  defaultOn={isFavorite}
                  onClick={this.handleFavoriteChange}
                />
                {showGroupGiftToggle && (
                  <div className="mll">
                    <GroupGiftToggle
                      disabled={!canEnableGroupGift}
                      defaultOn={isGroupGift}
                      onClick={this.handleGroupGiftChange}
                      onDisabledClick={this.handleGroupGiftDisabled}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <Input
          label="Url"
          value={url}
          onChange={this.handleChange}
          name="url"
          groupClassName="mbs"
          error={url ? null : 'Url cannot be blank'}
        />

        {(!secondUrl || !secondPrice) && (
          <div className="text-right">
            <LinkButton
              className="h7 text-uppercase ms-hidden pan man"
              onClick={this.toggleSecondaryUrl}
            >
              Add another url
            </LinkButton>
          </div>
        )}

        {this.renderSecondaryUrl()}

        <Input
          label="Notes for friends and family"
          type="textarea"
          onChange={this.handleChange}
          name="description"
          value={description || ''}
          className={css.notes}
          placeholder={REG_ITEM_PLACEHOLDER_TEXT}
        />
      </>
    )
  }
}

RegItemFields.propTypes = {
  categories: PropTypes.array,
  regItem: PropTypes.object,
  onRegItemChange: PropTypes.func.isRequired,
  onNewCategoryChange: PropTypes.func.isRequired,
  openEnableGroupGiftModal: PropTypes.func.isRequired,
}
